import { env } from '@repo/platform-env';

export const LOGIN_PATH = '/api/nts/v1/login';

type SegmentTrackingAttributesType = {
  anonymousUserId: string;
  deployableName: string;
  deployableVersion: string;
  driverContentId: string;
  driverContentSource: string;
  driverElement: string;
  driverFlowName?: string;
  driverLocation: string;
  driverPageName: string;
  driverPageUrl: string;
  driverPageViewId: string;
  driverSubLocation: string;
  mostRecentTraditionalDeviceId?: string;
};

export type Options = {
  redirectTo: string;
  cancelCta?: string;
  cancelUrl?: string;
  initialScreen?: 'signin' | 'signup';
  brand?: string;
} & SegmentTrackingAttributesType;

export class Auth0 {
  private origin: string;

  constructor(origin: string) {
    this.origin = origin;
  }

  public generateAuthLink(options: Options) {
    const loginURL = new URL(LOGIN_PATH, this.origin);

    Object.entries(options).forEach(([key, value]) => {
      loginURL.searchParams.append(key, value);
    });

    return loginURL.toString();
  }

  signIn(options: Omit<Options, 'initialScreen'>) {
    window.location.assign(this.generateAuthLink({ initialScreen: 'signin', ...options }));
  }

  signUp(options: Omit<Options, 'initialScreen'>) {
    window.location.assign(this.generateAuthLink({ initialScreen: 'signup', ...options }));
  }
}

export const auth0 = new Auth0(
  env.NEXT_PUBLIC_DEPLOYABLE_ENV === 'prod'
    ? 'https://www.nerdwallet.com/'
    : 'https://stage.nerdwallet.biz/',
);
